const DEFAULT_FILTERS_KEYS_MAP = {
  CITY: "city",
  DEALER: "dealer",
  DEALERSHIP: "dealership",
  BRAND: "brand",
  MODEL: "model",
  PRICE: "price",
  VERSION: "version",
  PACKAGE: "package",
  ENGINE: "engine",
  GEARBOX: "gearbox",
  DRIVETRAIN: "drivetrain",
  EXTERIOR: "exterior",
  LOGISTIC_STATUS: "logisticStatus",
  TAG: "tag"
};
export {
  DEFAULT_FILTERS_KEYS_MAP
};
